import mapboxgl from 'mapbox-gl';
import MapboxDraw from '@mapbox/mapbox-gl-draw';
import MapService from '@/services/map.js';
import Auth from '@/services/auth.js';
import Utils from '../../../services/utils.js';
import API from "../../../services/API";

const markerWifi = require('@/assets/img/marker-wifi.png');
const markerBluetooth = require('@/assets/img/marker-bluetooth.png');
const markerNFC = require('@/assets/img/marker-nfc.png');
const markerQRCode = require('@/assets/img/marker-qrcode.png');

const markerWifiA = require('@/assets/img/marker-wifi-active.png');
const markerBluetoothA = require('@/assets/img/marker-bluetooth-active.png');
const markerNFCA = require('@/assets/img/marker-nfc-active.png');
const markerQRCodeA = require('@/assets/img/marker-qrcode-active.png');

const markersTypes = {
    '1': markerWifi,
    '2': markerBluetooth,
    '3': markerNFC,
    '4': markerQRCode,
    '5': markerBluetooth,
};

const markersTypesActive = {
    '1': markerWifiA,
    '2': markerBluetoothA,
    '3': markerNFCA,
    '4': markerQRCodeA,
    '5': markerBluetoothA,
};

export class Map {

    constructor(id, config, callBackLoad, center, zoom, pitching) {


        var that = this;

        //Initialisation des attributs
        this._container = "";
        this._config = {};
        this._draw = null;
        this._map = null;
        this._geojson = null;
        this._currentMarker = null;
        this._canvas = null;
        this._isCursorOverPoint = false;
        this._isDragging = false;
        this._markerGhost = null;
        this._markerPopup = null;
        this._HTMLMarkers = [];

        this._background = {
            data: '',
            width: 0,
            height: 0
        };

        mapboxgl.accessToken = MapService.accessToken;

        this._config = Object.assign(config);


        if (id != null) {
            this._container = id;
            this._config.container = id;
        }

        if (center != null) {
            this._config.center = center;
        }

        if (zoom != null) {
            this._config.zoom = zoom;
        }

        if (pitching == null) {
            pitching = false;
        }


        this._map = new mapboxgl.Map(config);


        this._canvas = this._map.getCanvasContainer();

        this._map.dragRotate._pitchWithRotate = pitching;

        var attPos = 'bottom-left';

        if (id.indexOf('widget') != -1) {
            attPos = 'bottom-right';
        }

        this._map.addControl(new mapboxgl.AttributionControl(), attPos);

        this._map.addControl(new mapboxgl.NavigationControl());


        this._draw = new MapboxDraw({
            displayControlsDefault: true,
            styles: [
                // ACTIVE (being drawn)
                // line stroke
                {
                    "id": "gl-draw-line",
                    "type": "line",
                    "filter": ["all", ["==", "$type", "LineString"], ["!=", "mode", "static"]],
                    "layout": {
                        "line-cap": "round",
                        "line-join": "round"
                    },
                    "paint": {
                        "line-color": "#FFCC00",
                        "line-width": 5
                    }
                },
                // polygon fill
                {
                    "id": "gl-draw-polygon-fill",
                    "type": "fill",
                    "filter": ["all", ["==", "$type", "Polygon"], ["!=", "mode", "static"]],
                    "paint": {
                        "fill-color": "#FFCC00",
                        "fill-outline-color": "#FFCC00",
                        "fill-opacity": 0.5
                    }
                },
                // polygon outline stroke
                // This doesn't style the first edge of the polygon, which uses the line stroke styling instead
                {
                    "id": "gl-draw-polygon-stroke-active",
                    "type": "line",
                    "filter": ["all", ["==", "$type", "Polygon"], ["!=", "mode", "static"]],
                    "layout": {
                        "line-cap": "round",
                        "line-join": "round"
                    },
                    "paint": {
                        "line-color": "#FFCC00",
                        "line-width": 5
                    }
                },
                // vertex point halos
                {
                    "id": "gl-draw-polygon-and-line-vertex-halo-active",
                    "type": "circle",
                    "filter": ["all", ["==", "meta", "vertex"], ["==", "$type", "Point"], ["!=", "mode", "static"]],
                    "paint": {
                        "circle-radius": 5,
                        "circle-color": "#FFF"
                    }
                },
                // vertex points
                {
                    "id": "gl-draw-polygon-and-line-vertex-active",
                    "type": "circle",
                    "filter": ["all", ["==", "meta", "vertex"], ["==", "$type", "Point"], ["!=", "mode", "static"]],
                    "paint": {
                        "circle-radius": 3,
                        "circle-color": "#FFCC00",
                    }
                },

                // INACTIVE (static, already drawn)
                // line stroke
                {
                    "id": "gl-draw-line-static",
                    "type": "line",
                    "filter": ["all", ["==", "$type", "LineString"], ["==", "mode", "static"]],
                    "layout": {
                        "line-cap": "round",
                        "line-join": "round"
                    },
                    "paint": {
                        "line-color": "#FFCC00",
                        "line-width": 3
                    }
                },
                // polygon fill
                {
                    "id": "gl-draw-polygon-fill-static",
                    "type": "fill",
                    "filter": ["all", ["==", "$type", "Polygon"], ["==", "mode", "static"]],
                    "paint": {
                        "fill-color": "#FFCC00",
                        "fill-outline-color": "#FFCC00",
                        "fill-opacity": 0.4
                    }
                },
                // polygon outline
                {
                    "id": "gl-draw-polygon-stroke-static",
                    "type": "line",
                    "filter": ["all", ["==", "$type", "Polygon"], ["==", "mode", "static"]],
                    "layout": {
                        "line-cap": "round",
                        "line-join": "round"
                    },
                    "paint": {
                        "line-color": "#FFCC00",
                        "line-width": 3
                    }
                }
            ]

        });


        this._map.on('load', function (e) {


            that.initLayers();


            if (callBackLoad != null) {
                callBackLoad(e);
            }


        });
    }

    initLayers() {


        var that = this;

        var emptyGeoJson = {
            type: "FeatureCollection",
            features: []
        };
        var geojson = null;

        if (this._geojson != null) {
            geojson = this._geojson;
        }
        else {
            geojson = emptyGeoJson;
        }

        if (!that._map.getSource("geojson")) {
            that._map.loadImage(markerBluetooth, (error, imageBT) => {
                that._map.addImage('marker-2', imageBT);
                that._map.addImage('marker-5', imageBT);
            })
            that._map.loadImage(markerWifi, (error, imageWF) => {

                that._map.addImage('marker-1', imageWF);
            })
            that._map.loadImage(markerNFC, (error, imageNFC) => {
                that._map.addImage('marker-3', imageNFC);
            })
            that._map.loadImage(markerQRCode, (error, imageQR) => {
                that._map.addImage('marker-4', imageQR);
            })
            that._map.loadImage(markerBluetoothA, (error, imageBTA) => {
                that._map.addImage('marker-2-active', imageBTA);
                that._map.addImage('marker-5-active', imageBTA);
            })
            that._map.loadImage(markerWifiA, (error, imageWFA) => {
                that._map.addImage('marker-1-active', imageWFA);
            })
            that._map.loadImage(markerNFCA, (error, imageNFCA) => {
                that._map.addImage('marker-3-active', imageNFCA);
            })
            that._map.loadImage(markerQRCodeA, (error, imageQRA) => {
                that._map.addImage('marker-4-active', imageQRA);

            });

        }

        if (!that._map.getSource("geojson")) {
            that._map.addSource('geojson', {
                "type": "geojson",
                "data": geojson
            });
        }

        if (!that._map.getLayer("zones-fill")) {
            that._map.addLayer({
                "id": "zones-fill",
                "type": "fill",
                "source": "geojson",
                'paint': {
                    'fill-color': '#FFCC00',
                    'fill-opacity': 0.4
                },
                "filter": ["==", "$type", "Polygon"]
            });
        }
        if (!that._map.getLayer("zones-line")) {
            that._map.addLayer({
                "id": "zones-line",
                "type": "line",
                "source": "geojson",
                'paint': {
                    'line-color': '#FFCC00',
                    'line-width': 5
                },
                "filter": ["==", "$type", "Polygon"]
            });
        }
        if (!that._map.getLayer("markers")) {
            that._map.addLayer({
                "id": "markers",
                "type": "symbol",
                "source": "geojson",
                "layout": {
                    "icon-image": "marker-{type}{active}",
                    "icon-size": 1,
                    "icon-allow-overlap": true,
                },
                "filter": ["==", "$type", "Point"]
            });
        }
        if (!that._map.getLayer("markers-plans")) {
            that._map.addLayer({
                "id": "markers-plans",
                "type": "symbol",
                "source": "geojson",
                "layout": {
                    "icon-image": "marker-{type}-active",
                    "icon-size": 0.8,
                    "icon-allow-overlap": true,
                },
                "paint": {
                    "icon-opacity": 0.5
                },
                "filter": ["==", "$type", "Point"]
            });
        }


    }

    switchEditDrawMode(active, drawing, callbackDrawn) {
        var that = this;
        if (active === true) {
            this._map.addControl(this._draw);

            var ids = this._draw.set({
                type: 'FeatureCollection',
                features: [drawing]
            });
            this._draw.changeMode(this._draw.modes.DIRECT_SELECT, {featureId: drawing.id});

            this.tempCallbackDrawn = callbackDrawn;

            this._map.on('draw.update', this.endEditDrawMode.bind(this));
        }
        else {
            this._draw.deleteAll();
            this._map.removeControl(this._draw);
        }

    }

    endEditDrawMode(drawn) {


    }

    switchDrawMode(active, callbackDrawn) {
        var that = this;
        if (active === true) {
            this._map.addControl(this._draw);

            this._draw.changeMode(this._draw.modes.DRAW_POLYGON);

            this.tempCallbackDrawn = callbackDrawn;

            this._map.on('draw.create', this.endDrawMode.bind(this));
        }
        else {
            this._draw.deleteAll();
            this._map.removeControl(this._draw);
        }

    }

    endDrawMode(drawn) {

        if (this.tempCallbackDrawn) {
            this._map.off('draw.create', this.endDrawMode);
            this.tempCallbackDrawn(drawn);
            this.tempCallbackDrawn = null;
        }

    }

    addGeoJson(geojson, soft = false) {

        if(this._map.getSource('geojson')) {
            if (soft === true) {
                this._map.setLayoutProperty("markers", 'visibility', 'none');
                this._map.setLayoutProperty("markers-plans", 'visibility', 'visible');
            } else {
                this._map.setLayoutProperty("markers", 'visibility', 'visible');
                this._map.setLayoutProperty("markers-plans", 'visibility', 'none');
            }

            this._geojson = geojson;

            this._map.getSource('geojson').setData(geojson);
        }
    }

    addMarker(properties) {

        if (this._geojson != null) {

            var marker = {
                "geometry": {
                    "coordinates": [0, 0],
                    "type": "Point"
                },
                "type": "Feature",
                "properties": properties
            };

            this._geojson.features.push(marker);
            this._map.getSource('geojson').setData(this._geojson);

        }

    }

    addHTMLMarker(content, lng, lat, classes, popup) {
        var el = document.createElement('div');
        el.className = classes;
        if (content.type == 'img') {
            el.style.backgroundImage = 'url(' + content.value + ')';

            if (content.icon) {
                const customIconElement = document.createElement('i')
                customIconElement.innerHTML = content.icon
                el.appendChild(customIconElement)
            }
        } else if (content.type == 'html') {
            el.innerHTML = content.value;
        }


        // add marker to map
        var marker = new mapboxgl.Marker(el, {offset: [0, 0]})
            .setLngLat([lat, lng])
            .addTo(this._map);

        if (popup != null) {
            marker.setPopup(popup);
        }

        this._HTMLMarkers.push(marker);

        return marker;
    }

    removeHTMLMarkers() {
        for (var i = 0; i < this._HTMLMarkers.length; i++) {
            this._HTMLMarkers[i].remove();
        }
    }

    activateMarker(id) {
        this._geojson.features.forEach((obj, idx) => {
            if (obj.properties.id == id + "") {
                obj.properties.active = "-active";
            }
            else {
                obj.properties.active = "";
            }
        });


        this._map.getSource('geojson').setData(this._geojson);
    }

    addPolygon(feature) {

        if (this._geojson != null) {

            this._geojson.features.push(feature);
            this._map.getSource('geojson').setData(this._geojson);

        }

    }

    removePolygon(id) {
        var that = this;

        for (var i = 0; i < this._geojson.features.length; i++) {
            if (this._geojson.features[i].properties.id == id) {
                that._geojson.features.splice(i, 1);
                break;
            }
        }

        this._map.getSource('geojson').setData(this._geojson);
    }

    clearFeatures() {
        this._geojson = {
            type: "FeatureCollection",
            features: []
        };

        var source = this._map.getSource('geojson');
        if (source) {
            source.setData(this._geojson);
        }

    }

  renderActionPointPopup(properties) {
    let image = properties.image !== null && properties.image !== "null" ? API.apiBaseURL+"attachment/"+ properties.image+"/300" : null;
    let imageBackgroundStyle = image !== null ? "style='background-image: url("+image+")'" : "";
    let batteryContent = "";
    let lastDetection = properties.lastDetection != null ? (new Date(properties.lastDetection)).toLocaleString() : null;
    if(properties.battery !== null && Number(properties.type) === 5)
    {
      let batteryClass = "battery-ok";
      if(properties.battery === "WARNING")
      {
        batteryClass = "battery-warning fa-battery-half";
      }
      if(properties.battery === "CRITICAL")
      {
        batteryClass = "battery-ko fa-battery-empty";
      }
      batteryContent = "<i class='fa "+batteryClass+" fa-battery'></i>";
    }
    let content = "<div>";
    content += "<div class='action-point-label'>"+batteryContent+ properties.name+"</div>";
    if(imageBackgroundStyle !== "")
    {
      content += "<div class='action-point-image' "+imageBackgroundStyle+"></div>";
    }
    if(Number(properties.type) === 5)
    {
      content += "<div class='action-point-serial'><span class='popup-label'>"+Utils.t('ap.library.form.serial')+" :</span><span>"+properties.serial+"</span></div>";
    }
    if(lastDetection !== null && Number(properties.type) === 5) {
      content += "<div class='action-point-last-detection'><span class='popup-label'>"+Utils.t('ap.lastDetected')+" :</span>" + lastDetection + "</div>";
    }
    if(properties.comment !== null) {
      content += "<div class='action-point-description'>" + properties.comment + "</div>";
    }
    content +="</div>";
    return content;
  }

    addPopup(soft = false) {
        var that = this;
        var layer = 'markers'

        if (soft === true) {
            layer = 'markers-plans'
        }


        this._map.on('mouseenter', layer, function (e) {

            var point = that._map.project([e.features[0].properties.lng, e.features[0].properties.lat]);
            var containerHeight = document.getElementById(that._container).offsetHeight
            var containerWidth = document.getElementById(that._container).offsetWidth

            that._markerPopup.innerHTML = that.renderActionPointPopup(e.features[0].properties);
            that._markerPopup.style.display = 'block';
            that._markerPopup.style.left = (point.x - 155) + 'px';
            that._markerPopup.style.top = (point.y + 20) + 'px';

            if((point.y + 20 + that._markerPopup.offsetHeight) > containerHeight - 20){
                that._markerPopup.style.top = (point.y - 20 - that._markerPopup.offsetHeight) + 'px';
            }

            if((point.x - 155 + that._markerPopup.offsetWidth) > containerWidth - 20){
                var offset = point.x - 155 + that._markerPopup.offsetWidth - containerWidth
                that._markerPopup.style.left = (point.x - 155 - offset - 20) + 'px';
            }
            if((point.x - 155) < 20){
                that._markerPopup.style.left = (20) + 'px';
            }

        })

        this._map.on('mouseleave', layer, function () {
            that._markerPopup.style.display = 'none';
            that._markerPopup.style.left = -40 + 'px';
            that._markerPopup.style.top = -40 + 'px';
        })

        this._map.on('mousedown', layer, function (e) {
            that._markerPopup.style.display = 'none';
            that._markerPopup.style.left = -40 + 'px';
            that._markerPopup.style.top = -40 + 'px';
        })

        this._markerPopup = document.getElementById(this._container).getElementsByClassName('marker-popup')[0];
    }

    addDragAndDrop(callbackDrop) {


        var that = this;

        this._callbackDrop = callbackDrop;

        this._map.on('mouseenter', 'markers', function (e) {


            if (!that._isDragging) {
                that._currentMarker = e.features[0].properties;
            }


            that._canvas.style.cursor = 'move';

            that._isCursorOverPoint = true;
            that._map.dragPan.disable();
        });

        this._map.on('mouseleave', 'markers', function () {

            if (!that._isDragging) {

                that._canvas.style.cursor = '';
                that._isCursorOverPoint = false;
                that._map.dragPan.enable();
            }
        });

        this._map.on('mousedown', 'markers', function (e) {

            if (!that._currentMarker) return;
            if (!that._isCursorOverPoint) return;

            that._isDragging = true;

            // Set a cursor indicator
            that._canvas.style.cursor = 'grab';

            that._markerGhost.getElementsByTagName('img')[0].setAttribute('src', markersTypes[that._currentMarker.type]);
            that._markerGhost.style.display = 'block';
            that._markerGhost.style.left = (e.originalEvent.offsetX - 25) + 'px';
            that._markerGhost.style.top = (e.originalEvent.offsetY - 25) + 'px';

            that._map.setFilter('markers', ["!=", "id", that._currentMarker.id]);

            // Mouse events
            that._map.on('mousemove', function (e) {

                if (!that._isDragging) return;
                var coords = e.lngLat;


                // Set a UI indicator for dragging.
                that._canvas.style.cursor = 'grabbing';


                that._markerGhost.style.left = (e.originalEvent.offsetX - 25) + 'px';
                that._markerGhost.style.top = (e.originalEvent.offsetY - 25) + 'px';


            });
            that._map.once('mouseup', function (e) {



                if (!that._isDragging) return;
                var coords = e.lngLat;
                // Print the coordinates of where the point had
                // finished being dragged to on the map.
                that._geojson.features[that._currentMarker.index].geometry.coordinates = [coords.lng, coords.lat];
                that._map.getSource('geojson').setData(that._geojson);

                that._map.setFilter('markers', null);

                that._markerGhost.style.display = 'none';
                that._markerGhost.style.left = -40 + 'px';
                that._markerGhost.style.top = -40 + 'px';

                if (that._callbackDrop) {
                    that._callbackDrop(that._currentMarker, coords);
                }



                that._canvas.style.cursor = '';
                that._isDragging = false;
                that._currentMarker = null;

                // Unbind mouse events
                that._map.off('mousemove');
                that._map.off('mouseup');
            });
        });

        this._markerGhost = document.getElementById(this._container).getElementsByClassName('marker-ghost')[0];
        this._markerPopup = document.getElementById(this._container).getElementsByClassName('marker-popup')[0];
    }

    addBackground(image) {
        if (image.data != '') {
            if (!this._map.getLayer("zones-fill") || !this._map.getLayer("zones-line") || !this._map.getLayer("markers") || !this._map.getLayer("markers-plans")) {
                this.initLayers();
            }
            if (this._map.getSource('background')) {
                this._map.removeSource('background')
            }
            this._background.data = image.data;
            this._background.width = image.width / 1000;
            this._background.height = image.height * -1 / 1000;

            this._map.addSource('background', {
                "type": "image",
                "url": this._background.data,
                "coordinates": [
                    [0, 0],
                    [this._background.width, 0],
                    [this._background.width, this._background.height],
                    [0, this._background.height]
                ]
            });
            this._map.addLayer({
                "id": "background",
                "source": "background",
                "type": "raster",
                "paint": {"raster-opacity": 1}
            });
            this._map.setMaxBounds([[-0.5, this._background.height - 0.5], [this._background.width + 0.5, 0.5]]);
            this._map.setCenter([this._background.width / 2, this._background.height / 2]);
            this._map.setZoom(8.5);

            this._map.moveLayer("zones-fill");
            this._map.moveLayer("zones-line");
            this._map.moveLayer("markers");
            this._map.moveLayer("markers-plans");

        }
    }

    _attributes() {


    }

}
